import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/sysCarModel/page',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/sysCarModel',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/sysCarModel/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/sysCarModel/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/sysCarModel/' + id,
method: 'put',
data: obj
})
}


export function carModelList() {
return request({
    url: '/api/admin/sysCarModel/all',
    method: 'get',
    data: {}
}).then(res=>{
    return res.map(x=>{
        return {value:x.id, label:x.carModel};
    });
})
}